const scrollIntoView = (el: HTMLElement, extraSpaces = 0) => {
  window.scroll({
    top: el.getBoundingClientRect().top + window.scrollY - extraSpaces,
    behavior: 'smooth',
  });
};

export default scrollIntoView;
